import { render } from "./ModalEditarEntradaEmble.vue?vue&type=template&id=60b7f6f6&scoped=true"
import script from "./ModalEditarEntradaEmble.vue?vue&type=script&lang=js"
export * from "./ModalEditarEntradaEmble.vue?vue&type=script&lang=js"

import "@/assets/styles/modal-styles.css?vue&type=style&index=0&id=60b7f6f6&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b7f6f6"]])

export default __exports__